export default __webpack_public_path__ + "static/workflowAutomationBg3-f2e1f71760a063745b1d8bdbe73ca040.png";